import React from "react";
import ActionGroup from "../components/ActionGroup";
import FaqList from "../components/FaqList";
import SiteLayout from "../components/SiteLayout";
import {
  colourAnalysisFaqs,
  colourAnalysisIncludes,
  colourAnalysisProcess,
  seasons,
} from "../siteContent";

const colourAnalysisActions = [
  { label: "Get Your Colour Analysis", to: "https://store.lizziefoxcolourstudio.com/product/colour-analysis/", variant: "solid" },
];

const ColourAnalysis = () => {
  return (
    <SiteLayout>
      <section className="page-hero page-hero--colour-analysis">
        <div className="container page-hero__grid colour-analysis-hero">
          <div className="colour-analysis-hero__copy">
            <h1>Your Colour Analysis</h1>
            {/* <h1>Discover the colours that make you feel most like yourself</h1> */}
            <p className="lead">
              A personalised online service that shows you which tones flatter
              your skin, support your hair direction, and simplify how you dress
              and present yourself.
            </p>
            <ActionGroup
              actions={colourAnalysisActions}
              className="colour-analysis-hero__actions"
            />
          </div>

          <figure className="colour-analysis-hero__image">
            <img
              alt="Dimensional colour result by Lizzie Fox Colour Studio"
              src="/images/colour-analysis-hero.png"
            />
          </figure>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="card-grid card-grid--three">
            {colourAnalysisProcess.map((item) => (
              <article className="detail-card" key={item.title}>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--tinted">
        <div className="container">
          <div className="section-heading">
            <p className="section-eyebrow">The Four Seasons</p>
            <h2>Your colour story starts here</h2>
          </div>

          <div className="season-grid-2 season-grid">
            {seasons.map((season) => (
              <article className="season-card" key={season.title}>
                <p>{season.palette}</p>
                <h3>{season.title}</h3>
                <p>{season.description}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--split">
        <div className="container split-layout">
          <div>
            <div className="section-heading">
              <p className="section-eyebrow">What’s Included</p>
              <h2>Practical guidance you can actually use</h2>
            </div>

            <ul className="check-list">
              {colourAnalysisIncludes.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </div>

          <div className="detail-card detail-card--accent accent-card-gap">
            <p className="section-eyebrow">Deliverables</p>
            <h3>Colour fan, hair direction, makeup guidance</h3>
            <p>
              Your analysis does more than tell you a season. It gives you a
              usable framework for wardrobe choices, future colour decisions,
              and a more coherent sense of personal style.
            </p>
            <ActionGroup actions={colourAnalysisActions} />
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="section-heading">
            <p className="section-eyebrow">FAQs</p>
            <h2>Common questions about colour analysis</h2>
          </div>
          <FaqList items={colourAnalysisFaqs} />
        </div>
      </section>
    </SiteLayout>
  );
};

export default ColourAnalysis;
